import * as Immutable from 'immutable';
import { ICON_TYPES } from './elementIconConstants';

export default (string, idPrefix = 'str') =>
    Immutable.Map({
        type: ICON_TYPES.STRING,
        id: `${idPrefix}-${string}`,
        string: string.toUpperCase(),
    });
